"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var MatomoContext_1 = __importDefault(require("./MatomoContext"));

var useOutboundClickListener_1 = __importDefault(require("./utils/useOutboundClickListener"));

function useMatomo() {
  var instance = react_1["default"].useContext(MatomoContext_1["default"]);

  var trackPageView = function trackPageView(params) {
    return instance.trackPageView && instance.trackPageView(params);
  };

  var trackEvent = function trackEvent(params) {
    return instance.trackEvent && instance.trackEvent(params);
  };

  var trackEvents = function trackEvents() {
    return instance.trackEvents && instance.trackEvents();
  };

  var trackSiteSearch = function trackSiteSearch(params) {
    return instance.trackSiteSearch && instance.trackSiteSearch(params);
  };

  var trackLink = function trackLink(params) {
    return instance.trackLink && instance.trackLink(params);
  };

  var enableLinkTracking = function enableLinkTracking() {
    return useOutboundClickListener_1["default"](instance);
  };

  return {
    trackEvent: trackEvent,
    trackEvents: trackEvents,
    trackPageView: trackPageView,
    trackSiteSearch: trackSiteSearch,
    trackLink: trackLink,
    enableLinkTracking: enableLinkTracking
  };
}

exports["default"] = useMatomo;